import { Image, ImageProps } from 'primitives/Image'
import { NoAssetFallback } from 'common/NoAssetFallback'
import { ImageAsset } from 'graphql/types'

export interface ImageMediaTileProps extends ImageProps {
  media: ImageAsset
  tileHeight?: string
  alt?: string
  showFallback?: boolean
}

export const ImageMediaTile: React.FC<ImageMediaTileProps> = ({
  media,
  alt = '',
  tileHeight = '100%',
  showFallback,
  imageProps,
  css,
}) => (
  <Image
    css={{
      height: '100%',
      objectFit: 'contain',
      ...css,
    }}
    src={showFallback ? '' : media.url}
    alt={alt}
    imageProps={{
      draggable: false,
      width: media.originalWidth,
      height: media.originalHeight,
      sizes: '(min-width: 544px) 544px, 100vw',
      ...imageProps,
    }}
    fallback={
      <NoAssetFallback
        assetType='image'
        css={{
          width: '100%',
          paddingBottom: tileHeight,
        }}
      />
    }
  />
)
